export default {
  saveSelectedTab: (context, payload) => {
    context.commit('setSelectedTab', payload)
  },
}
